import React, { useEffect, useState } from 'react';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import { getWorkItem } from 'utils/WorkItemsUtils';
import SkeletonForm from 'components/Shared/SkeletonForm';
import WorkItemSchema from 'schemas/workitems.schema.json';
import { useFormContext } from 'hooks/useFormContext';

const StaticWItemForm = ({ woItemNumber }) => {
    const { schema, updateSchema, ready, definitions } = useFormContext();
    const [defaults, setDefaults] = useState(null);

    useEffect(() => {
      const asyncEffect = async () => {
        const workitem = await getWorkItem(woItemNumber);
        setDefaults(workitem);
      };
      asyncEffect();
    }, [woItemNumber]);

    useEffect(() => {
      !schema && updateSchema(WorkItemSchema);
    })

    /* 
    on rare occasions, this component may be reached before the full AppContext is done initializing.
    so this form only renders when there is data in selectedProjectData 
    */
    return defaults && ready ? 
    withExtension(DynamicForm, { schema, defaultValues: defaults, disabledProperties: [], hiddenProperties:[], readOnly: true, definitions, cardStyles: {borderRadius: 0}, title: true }) :
    <SkeletonForm />
}




export default StaticWItemForm;
